//------------------------------------------------------------------------------
// Node Modules ----------------------------------------------------------------
import React from 'react';
import { useContext } from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
//------------------------------------------------------------------------------
// Style -----------------------------------------------------------------------
import styles from './index.module.scss';
//------------------------------------------------------------------------------
// Assets ----------------------------------------------------------------------
import { BannerImage } from '@cmp/images';

import { BannerImageResponsive } from '@cmp/images';
//------------------------------------------------------------------------------
// Helpers ----------------------------------------------------------------------
import { withTranslation } from 'react-i18next';
import chunk from 'lodash/chunk';
import { StoreConfigContext } from '@helpers/storeConfigContext';
//------------------------------------------------------------------------------
// React Class -----------------------------------------------------------------
class Banner extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: '',
    };
  }

  componentDidMount() {
    const {
      storeConfig: { language },
    } = this.context;
    this.setState({
      lang: language,
    });
  }
  render() {
    const componentClasses = classNames(styles.Banner);
    const { t } = this.props;
    const lang = this.state.lang;
    const isJapanese = lang === 'ja' ? true : false;
    const bannerWords = t('landing_OfferTheHill').split(' ');
    const BANNER_WORDS_CHUNK_SIZE = isJapanese ? bannerWords.length : 2;
    const chunks = chunk(bannerWords, BANNER_WORDS_CHUNK_SIZE);

    return (
      <div className={componentClasses}>
        <div className={styles.BannerContainer}>
          <BannerImage
            alt={t('landing_WithAHill')}
            className={styles.BannerImage}
          />
          <BannerImageResponsive
            alt={t('landing_WithAHill')}
            className={styles.BannerImageResponsive}
          />

          <div
            className={styles.BannerText}
            style={isJapanese ? { whiteSpace: 'pre-line' } : {}}
          >
            {chunks.map((chunk = []) => {
              const joinBy = isJapanese ? '\n' : ' ';
              const chunkedText = chunk.join(joinBy);

              return (
                <h1 key={chunkedText} className={styles.BannerTitle}>
                  {chunkedText}
                </h1>
              );
            })}

            <h3 className={styles.Subtitle}>
              {t('landing_WithAHill')}
              <br />
              {t('landing_WithAHill_2')}
            </h3>
          </div>
        </div>
        <h3 className={styles.SubtitleResponsive}>
          {t('landing_WithAHill')}
          <br />
          {t('landing_WithAHill_2')}
        </h3>
      </div>
    );
  }
}
//------------------------------------------------------------------------------
// Export ----------------------------------------------------------------------
export default withTranslation()(Banner);
Banner.contextType = StoreConfigContext;
